var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtChipCreditCard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0V0z",
    id: "pedvp5hw0a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#pedvp5hw0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.389 5.375-1.834-1.15a1.126 1.126 0 0 0-1.112.233L10.01 21.188c-.163.185-.359.446-.52.79a3.543 3.543 0 0 0-.316 1.693v20.487a.455.455 0 0 0 .299.428l1.647.975.384-22.65L40.389 5.374z",
    fill: "#F1CA6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.96 44.872V24.773c-.012-.288-.01-1.131.54-1.863.204-.269.427-.451.611-.572l27.28-16.733.573-.317a.78.78 0 0 1 .557.158c.36.287.31.79.31.813v20.783a2.997 2.997 0 0 1-.49 1.127c-.301.42-.642.66-.846.782l-27.44 16.733c-.045.034-.274.2-.55.134-.3-.07-.532-.381-.55-.767",
    fill: "#F6E4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473C20",
    d: "M10.979 26.572v3.214L40.822 11.63V8.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.024 30.096v6.592l24.55-14.94v-6.654"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473C20",
    d: "M27.923 30.598v.415l10.854-6.702v-.463M27.96 32.106v.416L38.81 25.82v-.464M27.987 33.541v.416l10.853-6.704v-.462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.773 43.052v-3.855a.96.96 0 0 1 .525-.556l2.764-1.68c.165-.018.304.045.345.151a.213.213 0 0 1 .012.11v3.669a.52.52 0 0 1-.09.284.504.504 0 0 1-.295.208l-3.023 1.833c-.11.04-.2.039-.228-.005a.065.065 0 0 1-.009-.036l-.003-.125.002.002z",
    fill: "#E8B240"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtChipCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-chip-credit-card.f3320a017e42211f20b46ba0a6698283.svg";